import { queryOptions, skipToken } from "@tanstack/react-query";

import { MASTER_INVALIDATION_KEY } from "@/api/queryClient";
import {
  getCaseTemplateById,
  getCaseTemplatesByWorkspaceId,
  type ListCaseTemplatesByWorkspaceIdProps,
} from "@/api/resources/caseTemplates/api";
import i18n from "@/providers/i18n";

const entity = i18n.t("case-template");
const entityErrorMessage = {
  text: i18n.t("notify.error-reason.unexpected"),
  title: i18n.t("notify.get.error", { e: entity }),
};
const entities = i18n.t("case-templates");
const entitiesErrorMessage = {
  text: i18n.t("notify.error-reason.unexpected"),
  title: i18n.t("notify.get.error", { e: entities }),
};

export const caseTemplatesQueryKeys = {
  all: () => [...MASTER_INVALIDATION_KEY, "caseTemplates"],
  lists: () => [...caseTemplatesQueryKeys.all(), "list"],
  listByWorkspaceId: (props: ListCaseTemplatesByWorkspaceIdProps) => [
    ...caseTemplatesQueryKeys.lists(),
    "byWorkspaceId",
    props,
  ],
  byId: (id?: string) => [...caseTemplatesQueryKeys.all(), "byId", id],
};
export const caseTemplatesQueries = {
  listByWorkspaceId: (props: ListCaseTemplatesByWorkspaceIdProps) =>
    queryOptions({
      queryKey: [...caseTemplatesQueryKeys.listByWorkspaceId(props)],
      queryFn: () => getCaseTemplatesByWorkspaceId(props),

      meta: {
        errorMessage: entitiesErrorMessage,
      },
    }),
  byId: (id?: string) =>
    queryOptions({
      queryKey: [...caseTemplatesQueryKeys.byId(id)],
      queryFn: id ? () => getCaseTemplateById(id) : skipToken,

      meta: {
        errorMessage: entityErrorMessage,
      },
    }),
};
